<template>
  <section id="pagePath">
    <div class="d-flex flex-column align-items-center justify-content-center py-5 mb-4">
      <div>
        <h2 class="font-w-600 fontsize-xheavy text-color-theme-dark">
          {{ pathTitle }}
        </h2>
      </div>
      <div class="d-flex align-items-center gap-10">
        <router-link to="/" class="d-flex align-items-center">
          <HomeIcon />
          <span class="font-w-600 font-s-14 text-color-theme-grey1">خانه</span>
        </router-link>
        <LeftChevronIcon />
        <router-link
          class="font-w-600 font-s-14 text-color-theme-grey1"
          :to="pathTo1 ? pathTo1 : ''"
          >{{ pathTitle1 }}</router-link
        >
        <LeftChevronIcon v-if="pathTitle2" />
        <router-link
          class="font-w-600 font-s-14 text-color-theme-grey1 text-overflow"
          :to="$route.path"
          v-if="pathTitle2"
          >{{ pathTitle2 }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import HomeIcon from "@/parts/Front/components/Icon/HomeIcon.vue";
import LeftChevronIcon from "@/parts/Front/components/Icon/LeftChevron.vue";
export default {
  name: "PagesPath",
  components: { HomeIcon, LeftChevronIcon },
  props: ["pathTitle1", "pathTo1", "pathTitle2", "pathTitle"],
  methods: {
    backLink() {
      history.back();
    },
  },
};
</script>

<style scoped>
#pagePath {
  background: url(../../../assets/images/breadcrumbbg.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
#pagePath .text-overflow {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
